/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { DocumentSelector } from "cms/documents/document-selector";
import { Logger } from "cms/utils/log/logger";

const DocumentSelectorWrapper = (props) => {

    const {
        document,
        setDocument,
        AddComponent,
        DisplayComponent,
        onDocumentSelect,
        onChooseDocumentHandler,
        onDocumentChange, // onDocumentChange is called when a document is selected or changed
        // onDocumentRemove, // onDocumentRemove is called when a document removed (empty the selection)
    } = props || {};

    // const [loadingDocument, setLoadingDocument] = useState()
    
    const handleCancel = async () => {
        Logger.debug("[DocumentSelectorWrapper] handleCancel - not implemented");
    };

    const onSelectDocument = async (document) => {
        Logger.debug("selected", document);
        setDocument(document);
        onDocumentSelect(document);
        // onDocumentChange(document)
    };
    const onChooseDocument = async (document) => {
        Logger.debug("chosen", document);
        //setDocument(document)
        onChooseDocumentHandler(document);
    };
    const onSaveDocument = async (doc) => {
        setDocument(doc);
        onDocumentChange(doc);
        // onDocumentChoose(doc)
    };

    return (
        <DocumentSelector
            AddComponent={AddComponent} // optional
            DisplayComponent={DisplayComponent} // optional
            document={document}
            setDocument={setDocument}
            onSaveDocumentHandler={onSaveDocument}
            onSelectDocumentHandler={onSelectDocument}
            onChooseDocumentHandler={onChooseDocument}
            handleCancel={handleCancel}
        />
    );
};

export { DocumentSelectorWrapper };
